import Image from 'app/Components/Shared/Image/image';
import React, {useMemo, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col, Button} from 'reactstrap';
import Config from '../../../Config';
import {prepareNewWindowUrl, getDataFromIContentRepo, buildUrlAndNavigate} from '../../../utilities/StringHelpers/StringHelpers';
import {setReducedSocsForFamilyMember} from 'app/Components/Page/SelfCarePage/SelfCareSlice';
import {
  setCurrentSubscriber,
  IsCollaborationInsuranceAllowed,
  GetCollaborationInsuranceData,
  closeModal,
  setPurchasedAddonsList,
  openModal,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {gaReportAbroadInsurance} from '../CollaborationInsuranceBlock/abroadInsuranceGA';
import {abroadInsuranceEnum} from '../CollaborationInsuranceBlock/abroadInsuranceGAEnum';
import AbroadAddonComponent from './AbroadAddons/AbroadAddonComponent';
import Carousel from './Carousel/Carousel';
import {dwhAbroadAddonsSuccessPage} from '../CellcomAbroadLobbyBlock/dwhReports';
import FailedSurfBlockRemovePopUp from '../CellcomAbroadLobbyBlock/Popups/FailedSurfBlockRemovePopUp';
import {
  removeOtpData,
  setSaleActiveStep,
  goToPage,
  returnToLobby,
  saveToHistory,
  setActiveLobbyTab,
  getAbroadFamilyPackageDetails,
  setSelectedAbroadPackage,
  goToFamily,
  removeOtpDataChildren,
  getUnqualifiedSubsFamily,
  setFromSuccess,
  setIsSelectingAccountBusinessIndividual,
  setOtpPhone,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {saleActiveStep, customerTypeEnum, lobbyTabsEnum, pages, popupReasonEnum} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import PurchaseAdditionalPackageButtonComponent from './PurchaseAdditionalPackageButtonComponent';
import BtnPink from '../../Shared/Buttons/BtnPink';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import PopUp from '../../Shared/Popup/PopUp';
import {isMobile, isBrowser} from 'react-device-detect';
import {formatDatesToDifferentFormats} from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';
import {
  gaCompletedSuccessfulPage,
  gaOrderTheSamePackageForDifferentAccount,
  gaContinuePurchaseBusinessIndividual,
  gaReturnToLobbyFromTicket,
  gaReportBannerClick,
  gaToSelfCareLobbyFromTicketBusinessIndividual,
  gaOnLoadTicket,
} from './gaReports';
import {resetAuth, resetLoginData} from '../../../utilities/authentication/authenticationSlice';
import {abroadInsuranceCreateReportShowBannerAfterAbroadSale} from '../CollaborationInsuranceBlock/abroadInsurancReports';
import OtpValidationResultPopupConstructor from '../CellcomAbroadLobbyBlock/Popups/OtpValidationResultPopupConstructor';
import AddonTicketPopup from './AbroadAddons/AddonTicketPopup';
import CallFilterSocMsg from './CallFilterSocMsg';
import {DomainMarketCode, getMarketCode} from 'app/utilities/domain/domainConstants';

const CompletedSuccessfulComponent = (props) => {
  const isGolan = getMarketCode() == DomainMarketCode.GOLAN;
  const [androidCollapse, setAndroidCollapse] = useState(false);
  const [appleCollapse, setAppleCollapse] = useState(false);
  const [showAddonPopup, setShowAddonPopup] = useState(null);

  let abroadInsuranceEpi = props.data?.epiStyleInitializationData;

  // Add-ons of package- from epi
  let addons = props.data.selectedAbroadPackage?.addons;
  const maxAddonsToDisplay = 3; //for carousel
  let addonsComponentList = addons?.map((soc, index) => {
    return (
      <AbroadAddonComponent
        key={index}
        addon={soc}
        showPopup={(soc) => setShowAddonPopup(soc)}
        closePopup={() => setShowAddonPopup(null)}
      />
    );
  });
  const whatsAppUrl = `${Config.staticWebSiteUrl}/clm/5/79/`;

  const toggleAndroidCollapse = () => {
    if (appleCollapse) {
      setAppleCollapse(false);
    }
    setAndroidCollapse(!androidCollapse);
  };

  const toggleAppleCollapse = () => {
    if (androidCollapse) {
      setAndroidCollapse(false);
    }
    setAppleCollapse(!appleCollapse);
  };
  useEffect(() => {
    if (props.data.failedAtRemovingSurfBlock) {
      props.openModal(popupReasonEnum.FAILED_SURF_BLOCK_REMOVE);
      console.log(props.data);
    }
  }, [props.data.failedAtRemovingSurfBlock]);

  useEffect(() => {
    let subscriberNumber = props.data?.otpData?.otpPhone;
    const data = {
      subscriber: subscriberNumber,
    };

    let businessIndividualLobby = props.data.epiStyleInitializationData.businessIndividualLobby ? true : false;
    let isSeparatedSale = props.data.otpData.validatedCostumerData?.isSeparatedSale ? true : false;
    if (!businessIndividualLobby && !isSeparatedSale) {
      props.GetCollaborationInsuranceData(data);
    }
    if (addons) {
      var userData = props.authentication?.loginData?.userDetails;
      const dwhParams = {
        channel: props.data.activeLobbyTab && props.data.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
        message: 'Addons Displayed',
        param1: props.data.isJETAuthentication ? 'JET' : 'WEBSITE',
        param2: addons.map((addon) => addon.socCode).join(','),
        param3: props.data.selectedAbroadPackage?.isFamilyBonus
          ? 'בני משפחות'
          : props.data.epiStyleInitializationData.businessIndividualLobby
          ? 'Individual'
          : '',
        param4: userData?.contactNumber,
        param5: props.data.selectedCountries.map((c) => c.countryCode).join(','),
        costumerName: userData?.firstName + ' ' + userData?.lastName,
        idNumber: userData?.IDNumber,
        subscriber: props.data?.otpData?.otpPhone,
      };
      dwhAbroadAddonsSuccessPage({...dwhParams});
    }
    gaReportAbroadInsurance(abroadInsuranceEnum.SuccessPage);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
    let businessIndividualLobby = props.data.epiStyleInitializationData.businessIndividualLobby ? true : false;
    let isFamilyProcess = props.data?.otpData?.isFamilyProcess ? true : false;
    let isSeparatedSale = props.data.otpData.validatedCostumerData?.isSeparatedSale ? true : false;
    let startedFromPackage = props.data.startedFromPackage ? true : false;
    let unqualifiedSubs = props.data.otpData?.unqualifiedSubs ? props.data.otpData?.unqualifiedSubs : 0;
    let comingFromPackageManager = props.data?.comingFromPackageManager ? true : false;

    gaCompletedSuccessfulPage(
      props.businessOrPrivate,
      businessIndividualLobby,
      isFamilyProcess,
      isSeparatedSale,
      startedFromPackage,
      unqualifiedSubs,
      comingFromPackageManager,
      addons,
    );
    props.saveToHistory('abroadSuccess');
  }, [props?.data?.otpDataChildren?.otpPhone, props.data.otpData?.unqualifiedSubs]);

  const bannerData = useMemo(() => {
    return getBannerData();
  }, []);

  function getBannerData() {
    let bannerObj = {
      url: null,
      image: null,
    };
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      bannerObj.url = props.data.epiStyleInitializationData.bannerURLSaleBusinessIndividual;
      bannerObj.image = props.data.epiStyleInitializationData.bannerImageSaleBusinessIndividual;
    } else if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
      bannerObj.url = props.data.epiStyleInitializationData.bannerURLSaleBusinessSeparation;
      bannerObj.image = props.data.epiStyleInitializationData.bannerImageSaleBusinessSeparation;
    } else {
      switch (props.data.otpData.validatedCostumerData?.accountType) {
        case customerTypeEnum.PRIVATE:
          bannerObj.url = props.data.epiStyleInitializationData.bannerURLSalePrivate;
          bannerObj.image = props.data.epiStyleInitializationData.bannerImageSalePrivate;
          break;

        case customerTypeEnum.BUSINESS:
          bannerObj.url = props.data.epiStyleInitializationData.bannerURLSaleBusinessRegular;
          bannerObj.image = props.data.epiStyleInitializationData.bannerImageSaleBusinessRegular;
          break;
      }
    }
    if (bannerObj.url && bannerObj.image) {
      return bannerObj;
    }
    return null;
  }
  const goToSaleWithSamePackageData = (buttonName) => {
    gaOrderTheSamePackageForDifferentAccount(props.businessOrPrivate, props.data.startedFromPackage, buttonName);
    let params = `${props.data.selectedAbroadPackage?.socCode}, ${props.data.selectedAbroadPackage?.price} `;
    gaOnLoadTicket(
      props.businessOrPrivate,
      props.data?.otpData?.isFamilyProcess,
      props.data.startedFromPackage,
      props?.data?.comingFromPackageManager,
      props.data.epiStyleInitializationData.businessIndividualLobby,
      params,
    );

    if (
      props.authentication?.loginData?.isOtpAuthenticated ||
      (props.authentication?.loginData?.isFullAuthenticated && props.data.relatedPhoneNumbers?.length == 1)
    ) {
      // props.resetAuth();
      props.resetLoginData();
      props.removeOtpData();
    } else {
      props.setOtpPhone('');
    }
    props.saveToHistory();
    props.setSaleActiveStep(saleActiveStep.TICKET);
  };

  const goToSaleWithFamilyPackage = async () => {
    const reducedSocList = props.data.selectedAbroadPackage?.reducedSocs?.reducedSocList;
    if (isGolan && reducedSocList?.length > 0) {
      await props.setReducedSocsForFamilyMember({
        socCode: props.data.selectedAbroadPackage.socCode,
      });
      const reducedSocsLink = Config.staticWebSiteUrl + getDataFromIContentRepo('linkForReducedPackages')?.url;
      await buildUrlAndNavigate(reducedSocsLink);
      return;
    }

    let blockId =
      props.data.otpData.isOTPValidated && props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS
        ? props.data.epiStyleInitializationData.businessSocPackageFolderId
        : props.data.epiStyleInitializationData.privateSocPackageFolderId;
    await props.saveToHistory('abroadFamily');
    let objGetUnqualifiedSubsFamily;
    if (props.data.selectedAbroadPackage?.isGiveFamilyBonus) {
      const startDateParent = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
      objGetUnqualifiedSubsFamily = {
        SubscriberNoParent: props.data.otpData.otpPhone,
        SocCodePackageGiveFamilyBonus: props.data.selectedAbroadPackage.socCode,
        StartDateParent: startDateParent,
        blockId: blockId,
      };
    }
    if (props.data.selectedAbroadPackage?.isFamilyBonus) {
      const startDateParent = props.data.otpData.startDateParent;
      objGetUnqualifiedSubsFamily = {
        SubscriberNoParent: props.data.otpData.otpPhone,
        SocCodePackageGiveFamilyBonus: props.data.otpData?.socCodeParent,
        StartDateParent: startDateParent,
        blockId: blockId,
      };
    }

    props.getAbroadFamilyPackageDetails({
      blockId: blockId,
      socCode: props.data.selectedAbroadPackage.socCodeFamilyBonus,
      phoneNumber: props.data.otpData.otpPhone,
      objGetUnqualifiedSubsFamily,
    });
  };

  const continuePurchaseBusinessIndividual = (samePackage, buttonName) => {
    gaContinuePurchaseBusinessIndividual(buttonName);

    const params = {
      isSelecting: samePackage ? true : false,
      abroadLobbyActiveStep: samePackage ? pages.SALE : pages.LOBBY,
      removeSelectedAbroadPackage: samePackage ? false : true,
    };
    props.setIsSelectingAccountBusinessIndividual(params);
    if (samePackage) {
      props.context.navigateTo(props.data.businessIndividualData.selfCareBlockUrl);
    }
  };

  const navigateToAbroadInsurancePage = () => {
    props.setCurrentSubscriber(props.data.otpData.otpPhone);
    props.context.navigateTo(props.data?.epiStyleInitializationData?.abroadInsurancePage);
  };

  const goToSelfCareLobby = async () => {
    gaToSelfCareLobbyFromTicketBusinessIndividual();
    const params = {
      isSelecting: false,
      abroadLobbyActiveStep: pages.LOBBY,
      removeSelectedAbroadPackage: true,
    };
    props.setIsSelectingAccountBusinessIndividual(params);
    var content = await props.context.loadContentByPath(Config.businessLobbyUrl);
    props.context.navigateTo(content);
  };

  const returnToAbroadLobby = () => {
    if (!props.data.epiStyleInitializationData.businessIndividualLobby) {
      let isSeparatedSale = props.data.otpData.validatedCostumerData?.isSeparatedSale ? true : false;
      let isFamilyProcess = props.data.otpData?.isFamilyProcess ? true : false;
      let startedFromPackage = props.data.startedFromPackage ? true : false;
      gaReturnToLobbyFromTicket(props.businessOrPrivate, isFamilyProcess, isSeparatedSale, startedFromPackage);
    }
    if (props.data.isJETAuthentication) {
      props.context.navigateTo(props?.iContent?.linkForAbroadSelfCare.value?.url);
    } else {
      let activeTab = props.data.epiStyleInitializationData.businessIndividualLobby
        ? lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL
        : lobbyTabsEnum.PACKAGEEXISTS;
      props.setSaleActiveStep(saleActiveStep.LOADER);
      props.setFromSuccess(true);
      props.returnToLobby({activeTab});
    }
  };

  const startOver = () => {
    props.setSaleActiveStep(saleActiveStep.LOADER);
    props.setFromSuccess(true);
    props.returnToLobby({activeTab: lobbyTabsEnum.PRIVATE});

    if (
      props.authentication?.loginData?.isOtpAuthenticated ||
      (props.authentication?.loginData?.isFullAuthenticated && props.data.relatedPhoneNumbers?.length == 1)
    ) {
      props.resetLoginData();
      //props.resetAuth();
      props.removeOtpData();
    } else {
      props.setOtpPhone('');
    }
  };
  const isDataOnly = () => {
    let packageDetailsList = props.data.selectedAbroadPackage.packageDetailsList[0];
    return !packageDetailsList.sms.value && !packageDetailsList.voice.value;
  };

  function runReportOnStartup() {
    let userData = props.authentication?.loginData?.userDetails;
    let name = userData?.firstName + ' ' + userData?.lastName;
    let subscriberNumber = props.data.otpData.otpPhone;
    abroadInsuranceCreateReportShowBannerAfterAbroadSale(
      'Ongoing',
      'Insurance Banner Displayed',
      name,
      '',
      subscriberNumber,
      userData?.IDNumber,
    );
  }

  const contactPhone = window.Config.numberCallCenterAbroad;
  const runReportOnClick = () => {
    let userData = props.authentication?.loginData?.userDetails;
    let name = userData?.firstName + ' ' + userData?.lastName;
    let subscriberNumber = props.data.otpData.otpPhone;
    abroadInsuranceCreateReportShowBannerAfterAbroadSale(
      'Completed',
      'Insurance Banner Clicked',
      name,
      '',
      subscriberNumber,
      userData?.IDNumber,
    );
  };
  const buttonRendering = () => {
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      return (
        <>
          <Row className='mb-3 mt-3'>
            <Col className='text-center'>
              <PurchaseAdditionalPackageButtonComponent
                text={'ריכשו את אותה חבילה לאדם נוסף'}
                onClick={() => continuePurchaseBusinessIndividual(true, `ריכשו את אותה חבילה לאדם נוסף`)}
              />
            </Col>
          </Row>
          <Row className='mb-3  mt-3'>
            <Col className='text-center'>
              <PurchaseAdditionalPackageButtonComponent
                text={'ריכשו חבילה אחרת לאדם נוסף'}
                onClick={() => continuePurchaseBusinessIndividual(false, `ריכשו חבילה אחרת לאדם נוסף`)}
              />
            </Col>
          </Row>
          <Row className='mb-3 mt-3'>
            <Col className='text-center return-to-lobby-button'>
              <Button color='link' className='pink' onClick={() => goToSelfCareLobby()}>{`לאזור האישי>`}</Button>
            </Col>
          </Row>
        </>
      );
    } else {
      if (props.data.selectedAbroadPackage?.isGiveFamilyBonus && !props.data.otpData?.isFamilyProcess) {
        return (
          <>
            <Row className='mb-3 mt-3'>
              <Col className='text-center return-to-lobby-button'>
                <BtnSubmit text={'רכשו חבילה מוזלת לבני משפחה'} onclick={goToSaleWithFamilyPackage} />
              </Col>
            </Row>
          </>
        );
      } else if (props.data.otpData?.isFamilyProcess && props.data.otpData?.unqualifiedSubs < 5) {
        return (
          <>
            <Row className='mb-3 mt-3'>
              <Col className='text-center return-to-lobby-button'>
                <BtnPink text={'להוספת מנוי לחבילה המשפחתית'} onclick={goToSaleWithFamilyPackage} />
              </Col>
            </Row>
          </>
        );
      } else {
        return (
          <>
            {!props.data.isJETAuthentication &&
              (props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpAuthenticated) && (
                <Row className='mb-3 mt-3'>
                  <Col className='text-center'>
                    <BtnSubmit className='btn-design' text={'לרכישת חבילה לאדם נוסף'} onclick={startOver} />
                  </Col>
                </Row>
              )}
          </>
        );
      }
    }
  };

  let imageDesktop = '';
  if (abroadInsuranceEpi?.abroadInsuranceDesktopImage == null || abroadInsuranceEpi?.abroadInsuranceDesktopImage == '') {
    imageDesktop = require('./images/icon-73-check-mark.svg');
  } else {
    imageDesktop = Config.epiBaseUrl + abroadInsuranceEpi?.abroadInsuranceDesktopImage;
  }
  let imageMobile = '';
  if (abroadInsuranceEpi?.abroadInsuranceMobileImage == null || abroadInsuranceEpi?.abroadInsuranceMobileImage == '') {
    imageMobile = require('./images/icon-73-check-mark.svg');
  } else {
    imageMobile = Config.epiBaseUrl + abroadInsuranceEpi?.abroadInsuranceMobileImage;
  }

  useEffect(() => {
    if (props.showInsurance == true && !abroadInsuranceEpi?.abroadInsuranceAllowed) {
      runReportOnStartup();
      gaReportAbroadInsurance(abroadInsuranceEnum.BannerImp);
    }
  }, [props.showInsurance]);

  return (
    <Container className={`completed-successful-wrapper ${isMobile ? 'pr-0 pl-0 mobile-page-margin' : ''}`}>
      <Row>
        <Col className='completed-animation'>
          <Image src={require('./images/icon-73-check-mark.svg')} alt='check-mark' />
          {/* <Lottie options={{animationData: ApprovedAnimation, loop: false}} width={125} height={125} /> */}
        </Col>
      </Row>
      <Row>
        <Col className='completed-successful-title text-center'>
          <span className='bold d-block'>
            {!props.data.otpData.isFamilyProcess && `החבילה החדשה הוזמנה `}
            {props.data.otpData.isFamilyProcess && (
              <span>
                החבילה החדשה הותקנה
                <br />
                ב-{props.data.otpDataChildren.otpPhone}
              </span>
            )}
          </span>
        </Col>
      </Row>

      <Row>
        <Col className='completed-text'>
          {buttonRendering()}
          {props.data.selectedAbroadPackage?.showCallFilterMsg && <CallFilterSocMsg />}
          {addons?.length > 0 && (
            <div className='addons-container'>
              <div className='addons-title text-center '>
                <span className='bold d-block'>תוספות קטנות שמשדרגות המון</span>
              </div>
              <div className={`addons-block-row ${addons.length == 1 ? 'sigle-addon' : 'multiple-addons'}`}>
                {addons.length <= maxAddonsToDisplay || isMobile ? (
                  addonsComponentList
                ) : (
                  <Carousel items={addonsComponentList} maxToDisplay={maxAddonsToDisplay} />
                )}
              </div>

              {props.data.businessIndividualData.popupData && (
                <div className='addon-result-popup'>
                  <PopUp
                    showPopUp={props.data.isShowPopup}
                    onClose={() => {
                      props.closeModal();
                    }}>
                    <OtpValidationResultPopupConstructor popupData={props.data.businessIndividualData.popupData} />
                  </PopUp>
                </div>
              )}
              <PopUp
                className='addon-popup-container'
                showPopUp={showAddonPopup != null}
                onClose={() => {
                  setShowAddonPopup(null);
                }}>
                <AddonTicketPopup
                  addonToShow={showAddonPopup}
                  closePopup={() => setShowAddonPopup(null)}
                  relatedPackage={props.data.selectedAbroadPackage}
                />
              </PopUp>
            </div>
          )}

          {props.showInsurance == true && !abroadInsuranceEpi?.abroadInsuranceAllowed && (
            <div
              className='insurance-main-frame'
              onClick={() => {
                navigateToAbroadInsurancePage(), runReportOnClick(), gaReportAbroadInsurance(abroadInsuranceEnum.BannerClick);
              }}>
              {!isMobile ? (
                <Image style={{maxHeight: '240px'}} src={imageDesktop} alt='insurance-icon-desktop' />
              ) : (
                <Image style={{maxHeight: '220px'}} src={imageMobile} alt='insurance-icon-mobile' />
              )}
            </div>
          )}

          {props.showInsurance == true && !abroadInsuranceEpi?.abroadInsuranceAllowed && (
            <div className='insurance-info'>
              {!isMobile ? (
                <div>
                  <p className='insurance-info-txt' dangerouslySetInnerHTML={{__html: abroadInsuranceEpi?.abroadInsuranceLegalInfo}}></p>
                </div>
              ) : (
                <div>
                  <p className='insurance-info-txt' dangerouslySetInnerHTML={{__html: abroadInsuranceEpi?.abroadInsuranceLegalInfo}}></p>
                </div>
              )}
            </div>
          )}
          <div className='light-info'>
            <Image src={require('./images/light.svg')} alt='light-icon' />
            <span style={{marginRight: '5px', marginBottom: '12px'}}>חשוב לדעת לפני הטיסה</span>
            <div className='light-info-txt'>הפעילו עכשיו נדידת נתונים במכשיר כדי שהחבילה תעבוד לאחר הנחיתה</div>
          </div>
          <br></br>

          {!androidCollapse && (
            <div onClick={() => toggleAndroidCollapse()} className='android-collapse-area-close'>
              <span>יש לי אנדרואיד</span>
              <Image src={require('./images/down-arrow.svg')} alt='light-icon' />
            </div>
          )}

          {androidCollapse && (
            <div className='android-collapse-area-open' onClick={() => toggleAndroidCollapse()}>
              <div className='top-collapse-android-open'>
                <span>יש לי אנדרואיד</span>
                <Image src={require('./images/up-arrow.svg')} alt='light-icon' />
              </div>
              <div>
                {!isMobile ? (
                  <div>
                    <span className='d-block text-right'>
                      הגדרות
                      <span className='sign'>
                        <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                      </span>
                      חיבורים
                      <span className='sign'>
                        {' '}
                        <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                      </span>
                      רשתות תקשורת סלולרית
                      <span className='sign'>
                        {' '}
                        <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                      </span>
                      להפעיל
                    </span>
                    <span className='d-block'>את הכפתור "נתונים בנדידה"</span>
                  </div>
                ) : (
                  <div>
                    <span className='d-block text-right'>
                      הגדרות
                      <span className='sign'>
                        <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                      </span>
                      חיבורים
                      <span className='sign'>
                        {' '}
                        <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                      </span>
                      רשתות תקשורת
                      <span className='d-block' style={{marginBottom: '-5px'}}>
                        סלולרית
                        <span className='sign'>
                          {' '}
                          <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                        </span>
                        להפעיל את כפתור
                      </span>
                    </span>
                    <span className='d-block'>"נתונים בנדידה"</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {!appleCollapse && (
            <div onClick={() => toggleAppleCollapse()} className='apple-collapse-area-close'>
              <span>יש לי IOS</span>
              <Image src={require('./images/down-arrow.svg')} alt='light-icon' />
            </div>
          )}
          {appleCollapse && (
            <div className='apple-collapse-area-open' onClick={() => toggleAppleCollapse()}>
              <div className='top-collapse-apple-open'>
                <span>יש לי IOS</span>
                <Image src={require('./images/up-arrow.svg')} alt='light-icon' />
              </div>
              {!isMobile ? (
                <div>
                  <span className='d-block text-right'>
                    הגדרות
                    <span className='sign'>
                      {' '}
                      <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                    </span>
                    סלולרי
                    <span className='sign'>
                      {' '}
                      <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                    </span>
                    אפשרויות נתונים סלולריים
                    <span className='sign'>
                      {' '}
                      <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                    </span>
                    להפעיל
                  </span>
                  <span className='d-block'>את הכפתור "נתונים בנדידה"</span>
                </div>
              ) : (
                <div>
                  <span className='d-block text-right'>
                    הגדרות
                    <span className='sign'>
                      <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                    </span>
                    סלולרי
                    <span className='sign'>
                      {' '}
                      <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                    </span>
                    אפשרויות נתונים
                    <span className='d-block' style={{marginBottom: '-5px'}}>
                      סלולריים
                      <span className='sign'>
                        {' '}
                        <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                      </span>
                      להפעיל את כפתור
                    </span>
                  </span>
                  <span className='d-block'>"נתונים בנדידה"</span>
                </div>
              )}
            </div>
          )}

          <hr className='separate-line-success-comp' />

          <div className='my-abroad-link'>
            {!isMobile ? (
              <div>
                <span className='txt-first'>תוכלו לצפות בחבילה ומצב הניצול שלה באזור </span>
                <span className='txt-link' onClick={() => returnToAbroadLobby()}>
                  חו"ל שלי
                </span>
              </div>
            ) : (
              <div>
                <div className='txt-first'>תוכלו לצפות בחבילה ומצב הניצול שלה באזור </div>
                <div className='txt-link' onClick={() => returnToAbroadLobby()}>
                  חו"ל שלי
                </div>
              </div>
            )}
          </div>

          <div className='contact-us'>
            {!isMobile ? (
              <span className='contact-us-main-title'>אנחנו זמינים 24/7 בשיחת חינם מהארץ ומחו״ל</span>
            ) : (
              <div>
                <div className='contact-us-main-title'>אנחנו זמינים 24/7</div>
                <div className='contact-us-main-title'>בשיחת חינם מהארץ ומחו״ל</div>
              </div>
            )}
            <div className='contact-us-phone'>
              {!isMobile ? (
                <div>
                  <Image src={require('./images/icon_phone.svg')} alt='phone-icon' />
                  <span className='contact-us-phone-txt'>התקשרו עכשיו {contactPhone} </span>
                </div>
              ) : (
                <div
                  className='contact-us-phone-mobile'
                  onClick={() => prepareNewWindowUrl(`tel:${Config.numberCallCenterAbroad.replace('-', '')}`, props.context)}>
                  <Image src={require('./images/icon_phone.svg')} alt='phone-icon' />
                  <span className='contact-us-phone-txt-mobile'>התקשרו עכשיו {contactPhone}</span>
                </div>
              )}
            </div>
            <div className='contact-us-wa'>
              <span className='contact-us-wa-txt'>או ב-</span>
              <span onClick={() => prepareNewWindowUrl(whatsAppUrl, props.context)} className='contact-us-wa-link'>
                WhatsApp
              </span>
              <Image
                onClick={() => prepareNewWindowUrl(whatsAppUrl, props.context)}
                src={require('./images/icon_wa.svg')}
                alt='wa-icon'
                className='contact-us-wa-icon'
              />
            </div>
          </div>
        </Col>
      </Row>

      {bannerData && (
        <Row className='justify-content-md-center banner-wrapper text-center'>
          <Col>
            <a className='w-100 h-100 banner' href={bannerData.url}>
              <div className='banner-content'>
                <Image
                  src={Config.epiBaseUrl + bannerData.image}
                  alt='banner'
                  onClick={() => gaReportBannerClick(bannerData.url, props.businessOrPrivate, props.data.startedFromPackage)}
                />
              </div>
            </a>
          </Col>
        </Row>
      )}
      {/* {shouldDisplayPackageExists === true ? ( */}
      {/* <Row>
        <Col className='text-center return-to-package' onClick={() => returnToAbroadLobby()}>
          <Button color='link' className='toAbroadSelfCare-button'>
            <span className='d-block toAbroadSelfCare-button-icon'>
              <img src={images.personal}></img>
            </span>
            <span className='d-block toAbroadSelfCare-button-text' style={{ color: '#4a4a4a' }}>
              לאיזור חו"ל שלי
            </span>
          </Button>
        </Col>
      </Row> */}
      <PopUp
        className={'FailedSurfBlockRemovePopUp'}
        showPopUp={props.data.isShowPopup && props.data.popupReason == popupReasonEnum.FAILED_SURF_BLOCK_REMOVE}
        onClose={() => props.closeModal()}>
        <FailedSurfBlockRemovePopUp closeModal={() => props.closeModal()} />
      </PopUp>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  data: state.cellcomAbroad,
  authentication: state.authentication,
  insuranceData: state.cellcomAbroad.abroadPermanentInsuranceSocData,
  showInsurance: state.cellcomAbroad.abroadInsurance?.showInsurance,
  showAddonPopup: state.cellcomAbroad.showAddonPopup,
});

const mapDispatchToProps = {
  openModal,
  setSaleActiveStep,
  goToPage,
  setActiveLobbyTab,
  getAbroadFamilyPackageDetails,
  setSelectedAbroadPackage,
  goToFamily,
  removeOtpDataChildren,
  getUnqualifiedSubsFamily,
  setFromSuccess,
  saveToHistory,
  removeOtpData,
  resetAuth,
  resetLoginData,
  returnToLobby,
  setIsSelectingAccountBusinessIndividual,
  setOtpPhone,
  IsCollaborationInsuranceAllowed,
  GetCollaborationInsuranceData,
  setCurrentSubscriber,
  closeModal,
  setPurchasedAddonsList,
  setReducedSocsForFamilyMember,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompletedSuccessfulComponent);
